/* eslint-disable import/prefer-default-export */

export const phoneRegexPattern = /^([0-9*#+-xX() ]{7,20})$/;